import React, { useState } from "react";
import { decodeShopifyId } from "@app/scripts/utils/index";
import _ from "lodash";

type Props = {
    products: any;
    handleChangeVariant: (Id: number, variantType: string, parentId: number) => void;
    defaultTitle?: string;
    selectedVariant?: any;
    variantType: string;
};

export const ProductGwpCartSelect: React.FC<Props> = ({
    products,
    handleChangeVariant,
    defaultTitle = "Select Option",
    selectedVariant,
    variantType,
}) => {
    const [defaultVisible, setDefaultVisible] = useState(true);

    const changeVariant = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedValue = e.target.value;

        const selectedOption = products?.find((variant: any) =>
            variantType === "size"
                ? variant.id == parseInt(selectedValue)
                : variant.variant_id == selectedValue
        );

        if (selectedOption) {
            const variantId = variantType === "size"
                ? selectedOption.id
                : Number(decodeShopifyId(selectedOption.variants?.[0]?.id, "ProductVariant"));

            handleChangeVariant(variantId, variantType, selectedOption.parentId);
        }

        setDefaultVisible(false);
    };

    const key = variantType === "size" ? "title" : "colour";
    const sortedVariants = products?.sort((a: any, b: any) => {
        if (a[key] === selectedVariant) return -1;
        if (b[key] === selectedVariant) return 1;
        return 0;
    });

    return sortedVariants && sortedVariants.length > 0 ? (
        <div className="product__variant-picker _field _field__select">
            <select
                className="select__select"
                name={variantType === "size" ? "Size" : "Colour"}
                onChange={changeVariant}
                defaultValue={selectedVariant}
            >
                {!selectedVariant && defaultVisible && (
                    <option value="__default">{defaultTitle}</option>
                )}
                {sortedVariants?.map((variant: any) => (
                    <option
                        key={variantType === "size" ? variant.id : variant.variant_id}
                        value={variantType === "size" ? variant.id : variant.variant_id}
                        disabled={variantType === "size" ? variant?.currentlyNotInStock : variant.available === false}
                    >
                        {variantType === "size" ? variant.title : variant.colour}
                    </option>
                ))}
            </select>
        </div>
    ) : null;
};
